import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import {
    Pagination,
    EffectFade,
    Navigation,
    Autoplay
} from 'swiper/modules';

import { imageUrl } from '../../Constants/contant';

import './BannerOne.css';

function BannerOne({ sliders }) {

    const swiperRef = useRef(null);

    return (

        <div className="th-hero-wrapper" id="hero">

            <Swiper

                ref={swiperRef}

                slidesPerView={1}

                loop={true}

                effect="fade"

                speed={1000}

                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                }}

                navigation={{
                    nextEl: '.slider-next',
                    prevEl: '.slider-prev',
                }}

                pagination={{
                    clickable: true,
                }}

                modules={[
                    Pagination,
                    EffectFade,
                    Navigation,
                    Autoplay
                ]}

                className="mySwiper"
            >

                {sliders && sliders.length > 0 ? (

                    sliders.map((item, index) => (

                        <SwiperSlide key={index}>

                            <div className="hero-inner">

                                <div
                                    className="th-hero-bg"
                                    style={{
                                        backgroundImage: `url(${imageUrl}${item.image})`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                    }}
                                ></div>

                            </div>

                        </SwiperSlide>

                    ))

                ) : (

                    <p style={{ textAlign: "center" }}>
                        Loading sliders...
                    </p>

                )}

                {/* CUSTOM NAVIGATION */}

                {/* <div className="th-swiper-custom">

                    <button className="slider-arrow slider-prev">

                        <img
                            src="/assets/img/icon/right-arrow.svg"
                            alt="Prev"
                        />

                    </button>

                    <div className="swiper-pagination"></div>

                    <button className="slider-arrow slider-next">

                        <img
                            src="/assets/img/icon/left-arrow.svg"
                            alt="Next"
                        />

                    </button>

                </div> */}

            </Swiper>

        </div>

    );
}

export default BannerOne;